import {clsx} from "clsx";

export const ShadowBox: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div className={clsx("shadow-[0px_0px_20px_5px_rgba(0,0,0,0.1)]", className)} {...props} />
  );
};
